// import UI from 'nr.os-ui'
// const nros = UI.nros
import nros from "./common/nros"
import axios from 'axios';

/**对于$http的封装 */
let $http = nros.getPlugin('http');

/**对于nrosUtil的封装 */
let nrosUtil = {
    nros
};

//检测登录会话时效
nrosUtil.checkLogin = () => {
    return new Promise((resolve, reject) => {
        var newApiCheckLogin = '/nvwa/checkLogin',
            params = {
                "encrypted": true
            };
        $http.post(newApiCheckLogin, params).then(response => {
            resolve(response)
        }).catch(error => {
            console.log(error.response.status)
            reject(error)
        })
    })
}
//检测tgt
nrosUtil.checkTGT = () => {
    return new Promise((resolve, reject) => {
        if(localStorage.getItem("TGT")){
            let TGT = localStorage.getItem("TGT")
            var config = {
                method: 'get',
                url: `${window.osConfig.ossUrl}/cas/v1/tickets/${TGT}`,
                headers: { 
                    'Accept': 'application/json', 
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
            axios(config).then(function (response) {
              if(response.status == 200){
                resolve(true)
              }else{
                resolve(false)
              }
            })
            .catch(function (error) {
                reject(error)
            });
        }else{
            resolve(false)
        }
    })
}


//获取tokenId方法
nrosUtil.getAuthorization = () => {
    //nros.getPlugin("login").load(nros.getPlugin('config').getConfig().storageMode).token
    let token = nros.getPlugin("login").getToken();
    return token ? token : (window.nros.token ? window.nros.token : null)
}

//有关登录校验成功后的相关处理逻辑,params为登录要传的参数信息
nrosUtil.login = (params) => {
    return new Promise((resolve, reject) => {
        nros.getPlugin("login").login(params).then(result => {
            $http.setHeaders(nros.getPlugin("login").getHeader());
            nros.getPlugin("login").store(nros.getPlugin("config").getConfig().storageMode);
            resolve(result)
        }).catch(error => {
            reject(error)
        })
    })
}


//获取登录内容
nrosUtil.getLoginContext = () => {
    return new Promise((resolve, reject) => {
        $http.get("/nvwa/getLoginContext").then(data => {
            resolve(data)
        }).catch(error => {
            reject(error)
        })
    })
}


export {
    nrosUtil,
    $http
}


// WEBPACK FOOTER //
// ./src/nros-util.js